import { render, staticRenderFns } from "./ProductionSummaryPanel.vue?vue&type=template&id=0b2016ac&"
import script from "./ProductionSummaryPanel.vue?vue&type=script&lang=js&"
export * from "./ProductionSummaryPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports